import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useDebounce } from "@/hooks/use-debounce";

interface AuthorFilesFiltersProps {
  search: string;
  onSearchChange: (search: string) => void;
}

export function AuthorFilesFilters({
  search,
  onSearchChange,
}: AuthorFilesFiltersProps) {
  const [searchInput, setSearchInput] = useState(search);
  const debouncedSearch = useDebounce(searchInput, 300);

  useEffect(() => {
    if (debouncedSearch !== search) {
      onSearchChange(debouncedSearch);
    }
  }, [debouncedSearch, search, onSearchChange]);

  return (
    <div className="relative flex-1 max-w-sm">
      <Search className="text-muted-foreground absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
      <Input
        placeholder="파일 제목으로 검색..."
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        className="pl-9 h-11 md:h-9"
        aria-label="Search author files"
      />
    </div>
  );
}
